class Countdown {
    constructor(htmlElement) {
        this.scheduleDays = JSON.parse(htmlElement.dataset.timers);
        this.initialOffset = Date.parse(new Date()) - htmlElement.dataset.current;

        this.texts = htmlElement.querySelectorAll(".kac-singlecountdown");

        for (let tag of this.texts) {
            tag.innerHTML = tag.innerHTML.replace(
                /!KANALCCOUNTDOWN/g,
                "<span class='kac-singlecountdown-timer'></span>"
            );
        }

        this.clockIndex = 0;

        // finde heraus, welche Countdowns bereits zu Beginn des Skripts abgelaufen sind
        while (this.getTimeRemaining(this.scheduleDays[this.clockIndex]) <= 0) {
            this.iterateClockIndex();
        }

        this.texts[this.clockIndex].style.display = "block";
        this.updateTimer();

        let self = this;
        setInterval(function() {
            self.updateTimer();
        }, 1000);
    }

    getTimeRemaining(endtime) {
        const t = endtime - Date.parse(new Date()) - this.initialOffset;

        return {
            'total': t,
            'days': Math.floor( t/(1000*60*60*24) ),
            'hours': Math.floor( (t/(1000*60*60)) % 24 ),
            'minutes': Math.floor( (t/1000/60) % 60 ),
            'seconds': Math.floor( (t/1000) % 60 )
        };
    }

    updateTimer() {
        const addLeadingZero = ( number => ('0' + number).slice(-2) );

        const { days, hours, minutes, seconds, total } = this.getTimeRemaining(this.scheduleDays[this.clockIndex]);

        let timerText;

        if (days > 0) {
            timerText = days + (days > 1 ? " Tage, " : " Tag, ")
                      + hours + "h "
                      + addLeadingZero(minutes) + "m "
                      + addLeadingZero(seconds) + "s";
        } else if (hours > 0) {
            timerText = hours + "h "
                      + addLeadingZero(minutes) + "m "
                      + addLeadingZero(seconds) + "s";
        } else if (minutes > 0) {
            timerText = addLeadingZero(minutes) + "m "
                      + addLeadingZero(seconds) + "s";
        } else {
            timerText = addLeadingZero(seconds) + "s";
        }

        for (let timer of this.texts[this.clockIndex].querySelectorAll(".kac-singlecountdown-timer")) {
            timer.innerHTML = timerText;
        }

        if (total <= 0) {
            this.iterateClockIndex();
            this.updateTimer();
        }
    }

    iterateClockIndex() {
        this.texts[this.clockIndex].style.display = "none";

        if (++this.clockIndex >= this.scheduleDays.length) {             // Wenn alle Countdowns abgelaufen sind:
            for (let i = 0; i < this.scheduleDays.length; i++) { // Verschiebe alle Countdowns um eine Woche
                this.scheduleDays[i] += 604800000;             // i-ter Countdown = 7 * 24 * 60 * 60s
            }

            this.clockIndex = 0;
        }
        this.texts[this.clockIndex].style.display = "block";
    }
}

document.addEventListener('DOMContentLoaded', function() {
    for (let node of document.querySelectorAll(".kac-countdown")) {
        new Countdown(node);
    }
}, false);
